import script from "./MapTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./MapTemplate.vue?vue&type=script&setup=true&lang=js"

import "./MapTemplate.vue?vue&type=style&index=0&id=402e558c&lang=scss&scoped=true"

import exportComponent from "E:\\Projects\\big-screen\\ori\\nnu-data-viewer-1204\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-402e558c"]])

export default __exports__